<div [class.dark-theme]="themeService.isDark()">
    <router-outlet></router-outlet>
    <!-- *ngIf="!(location == '/login' || location == '/register' || location == '/coming-soon')" -->
   <app-footer *ngIf="!(currentPath === '/print-idcard' || currentPath === '/admitcard')"></app-footer>

    <!-- <app-theme-customizer></app-theme-customizer> -->
</div>